import React from "react";
import { Receipt } from "lucide-react";
import { formatBillingAmount } from "./_shared";
import { useLanguage } from "@/lib/LanguageContext";
import { instantDay } from "../../lib/calendarDay";

const STATUS_STYLE = {
  completed: "bg-emerald-100 text-emerald-700",
  initiated: "bg-amber-100 text-amber-700",
};

export default function TransactionsTable({ txns, t }) {
  const { lang } = useLanguage();
  return (
    <div className="bg-white border border-eh-border-soft rounded-2xl overflow-hidden">
      <div className="p-6 border-b border-eh-border-soft flex items-center gap-2">
        <Receipt className="w-5 h-5 text-eh-muted" />
        <h3 className="font-display text-xl text-eh-ink">{t("bill.recentTx")}</h3>
      </div>
      {txns.length === 0 ? (
        <p className="p-8 text-center text-eh-muted text-sm">{t("bill.noTx")}</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-eh-cream/40 text-eh-muted text-xs uppercase tracking-wider text-left">
            <tr>
              <th className="px-6 py-3">{t("bill.colDate")}</th>
              <th className="px-6 py-3">{t("bill.colType")}</th>
              <th className="px-6 py-3">{t("bill.colAmount")}</th>
              <th className="px-6 py-3">{t("bill.colStatus")}</th>
            </tr>
          </thead>
          <tbody>
            {txns.map((tx) => (
              <tr key={tx.id} className="border-t border-eh-border-soft">
                <td className="px-6 py-3 text-eh-muted">{instantDay(tx.created_at, lang) || "—"}</td>
                <td className="px-6 py-3">{tx.plan_id} ({t("bill.txSubscription")})</td>
                <td className="px-6 py-3">{formatBillingAmount(tx.amount, tx.currency)}</td>
                <td className="px-6 py-3">
                  <span className={`px-2 py-0.5 rounded text-xs ${STATUS_STYLE[tx.status] || "bg-rose-100 text-rose-700"}`}>
                    {tx.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
